import { useGetList } from "react-admin";
import Calendar from "@/components/calendar/calendar";
import { useEffect, useState } from "react";
import { CalendarEvent, Mode } from "@/components/calendar/calendar-types";
import { Orders } from "@/interface/entityInterface";

const OrderReservations = () => {
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  const [mode, setMode] = useState<Mode>("month");
  const [date, setDate] = useState<Date>(new Date());

  const { data: orders = [] } = useGetList<Orders>("taxi-orders/scheduled", {
    pagination: { page: 1, perPage: 10000 },
    sort: { field: "", order: "DESC" },
  });

  useEffect(() => {
    if (orders.length === 0) return;
    const dataEvents: CalendarEvent[] = [];
    orders.map((order) => {
      let color = "";
      if (order.status === "NEW_ORDER") color = "yellow";
      else if (order.status === "ACCEPTED") color = "green";
      else if (order.status === "REJECTED" || order.status === "CANCELLED") color = "red";
      else color = "gray";
      dataEvents.push({
        ...order,
        id: "" + order.id,
        title: order.pickup,
        start: new Date(order.pickup_time),
        end: new Date(order.pickup_time),
        color,
      });
    });
    setEvents(dataEvents);
  }, [orders]);
  
  return (
    <div className="p-6">
      <Calendar
        events={events}
        setEvents={setEvents}
        mode={mode}
        setMode={setMode}
        date={date}
        setDate={setDate}
      />
    </div>
  );
};

export default OrderReservations;
